import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { showError } from '../utils/toast';

const PgLogin = ({ onLogin }) => {
  const navigate = useNavigate();
  const [username, setUsername] = useState(''); // Email ou CPF
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const [cpfError, setCpfError] = useState(false);

  const formatarCPF = (valor) => {
    // Remove tudo que não é número
    const numeros = valor.replace(/\D/g, '');
    
    if (numeros.length === 11) {
      // Formata CPF: 000.000.000-00
      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else if (numeros.length === 14) {
      // Formata CNPJ: 00.000.000/0000-00
      return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
    
    // Se não tiver 11 ou 14 dígitos, retorna null (inválido)
    return null;
  };

  const handleBlurCPF = (e) => {
    const valorFormatado = formatarCPF(e.target.value);
    
    if (valorFormatado) {
      setUsername(valorFormatado);
      setCpfError(false);
    } else if (e.target.value.trim() !== '') {
      // Se tem valor mas não é válido, marca como erro
      setCpfError(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validar se CPF/CNPJ está no formato correto antes de enviar
    if (cpfError) {
      showError('CPF ou CNPJ inválido');
      return;
    }
    
    setError('');
    setIsLoading(true);

    try {
      const response = await fetch('https://novo.faestal.com.br/login/login.php', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();
      
      if (data.status === 'success') {
        onLogin(data); // Passa os dados da sessão para o componente pai
      } else {
        showError('E-mail/CPF ou senha inválidos');
      }
    } catch (error) {
      console.error('Erro ao fazer login:', error);
      showError('Erro ao conectar com o servidor. Tente novamente.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center" style={{ backgroundColor: '#f5f5f5' }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-4">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5">
                <div className="text-center mb-4">
                  <img src="/coworking-itaguai-1.png" alt="Logo" className="img-fluid mb-3" style={{ maxWidth: '200px' }} />
                  <h2 className="mb-2">Portal do Cliente</h2>
                  <p className="text-muted">Acesse sua conta</p>
                </div>

                {error && (
                  <div className="alert alert-danger" role="alert">
                    {error}
                  </div>
                )}

                <form onSubmit={handleSubmit}>
                  <div className="mb-3">
                    <label className="form-label">CPF ou CNPJ</label>
                    <input
                      type="text"
                      className={`form-control form-control-lg ${cpfError ? 'is-invalid' : ''}`}
                      value={username}
                      onChange={(e) => {
                        setUsername(e.target.value);
                        setCpfError(false);
                      }}
                      onBlur={handleBlurCPF}
                      required
                      disabled={isLoading}
                      placeholder="Digite seu CPF ou CNPJ"
                    />
                    {cpfError && (
                      <div className="invalid-feedback d-block">
                        CPF deve ter 11 dígitos ou CNPJ deve ter 14 dígitos
                      </div>
                    )}
                  </div>
                  <div className="mb-4">
                    <label className="form-label">Senha</label>
                    <input
                      type="password"
                      className="form-control form-control-lg"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                      disabled={isLoading}
                      placeholder="Digite sua senha"
                    />
                  </div>
                  <button 
                    type="submit" 
                    className="btn btn-primary btn-lg w-100"
                    disabled={isLoading}
                    style={{ backgroundColor: '#27355c', borderColor: '#27355c' }}
                  >
                    {isLoading ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Entrando...
                      </>
                    ) : (
                      'Entrar'
                    )}
                  </button>
                  
                  <div className="text-center mt-3">
                    <button
                      type="button"
                      className="btn btn-link"
                      onClick={() => navigate('/cadastro')}
                      style={{ color: '#27355c' }}
                    >
                      Não tem conta? Cadastre-se
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PgLogin;
